// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sandbox-banner{position:fixed;z-index:20;bottom:0;left:0;right:0;background-color:rgba(0,0,0,.18);display:flex;padding:8px;align-items:center;justify-content:center;color:#fff;font-size:16px;line-height:24px;text-align:center}@media screen and (max-width: 475px){.sandbox-banner{display:none}}", ""]);
// Exports
module.exports = exports;
